import { Component, Input, OnInit, ViewChild, AfterViewInit, TemplateRef, Injector, Optional, Host } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChildParentTalk } from '../../data-models/child-parent-talk';
import { EasyFormComponent } from '../form/form.component';

@Component({
    selector: 'formGroup',
    templateUrl: 'form-group.component.html',
})
export class FormGroupComponent extends ChildParentTalk implements OnInit {

    get familyId() { return 'group'; }

    constructor( @Optional() @Host() private parentForm: EasyFormComponent, protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
    }

    ngAfterViewInit() {

    }

    tellYourParents() {
        this.parentForm.takeChild(this);
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/form-group/form-group.component.ts